/*eslint sort-keys: "error"*/
/*eslint-env es6*/
function http(endpointPath, method) {
  return (accessToken, obj) => {
    let path = endpointPath;
    if (typeof path === 'function') {
      path = endpointPath(obj);
    }

    var options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method: method
    };
    if (accessToken !== undefined) {
      options.withCredentials = true;
      options.credentials = 'include';
      options.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    if (
      (method === 'POST' || method === 'PUT' || method === 'DELETE') &&
      obj &&
      obj !== 'null' &&
      obj !== 'undefined'
    ) {
      options.body = JSON.stringify(obj);
    }
    return fetch(`${process.env.REACT_APP_API_URL}${path}`, options);
  };
}

function get(endpointPath) {
  return http(endpointPath, 'GET');
}

function post(endpointPath) {
  return http(endpointPath, 'POST');
}

function del(endpointPath) {
  return http(endpointPath, 'DELETE');
}
function put(endpointPath) {
  return http(endpointPath, 'PUT');
}

const API = {
  addCardanoWalletAnvil: post('/anvil/wallets/cardano'),
  addEthWallet: post('/multi/user/settings/wallets/eth'),
  addNiftyWallet: post('/multi/user/settings/wallets/nifty'),
  addWallet: post('/multi/user/settings/wallets'),
  adminAddNewCollection: put('/admin/shop/collections'),
  adminAddNewProduct: put(
    (pathParams) => `/admin/shop/collections/${pathParams.collectionId}/products`
  ),
  adminCreateDesktopClient: put('/admin/desktop-clients'),
  adminCreateEvent: put('/admin/events'),
  adminCreateStripePrice: post('/admin/shop/stripe/price'),
  adminCreateStripeProduct: post('/admin/shop/stripe/product'),
  adminCreateWebGPUBuild: post('/admin/webgpubuilds'),
  adminDeleteCollection: del((pathParams) => `/admin/shop/collections/${pathParams.collectionId}`),
  adminDeleteDesktopClient: del((id) => `/admin/desktop-clients/${id}`),
  adminDeleteEvent: del('/admin/events'),
  adminDeleteProduct: del(
    (pathParams) =>
      `/admin/shop/collections/${pathParams.collectionId}/products/${pathParams.productId}`
  ),
  adminDeleteWebGPUBuild: del((pathParams) => `/admin/webgpubuilds/${pathParams.version}`),
  adminGetAvailableDesktopClients: get('/admin/desktop-clients'),
  adminGetDesktopClientPresignedUrl: get(
    (randomObjectKey) => `/admin/desktop-client-presigned-url/${randomObjectKey}`
  ),
  adminGetEventBackgroundPresignedUrl: get(
    (eventId) => `/admin/events/${eventId}/background-presigned-url`
  ),
  adminGetEventDefaults: get('/admin/event-defaults'),
  adminGetEvents: get('/admin/events'),
  adminGetProductImagePresignedUrl: get(
    (pathParams) =>
      `/admin/shop/collections/${pathParams.collectionId}/products/${pathParams.productId}/image-presigned-url`
  ),
  adminGetServerInfo: get('/admin/server-info'),
  adminGetServers: get((eventId) => `/admin/events/${eventId}/servers`),
  adminGetShopHeroImagePresignedUrl: get('/admin/shop/hero-image-presigned-url'),
  adminGetStorefrontInfo: get('/admin/shop'),
  adminGetStripePrices: get((pathParams) => `/admin/shop/stripe/prices/${pathParams.productId}`),
  adminGetWebGPUBuild: get((pathParams) => `/admin/webgpubuilds/${pathParams.version}`),
  adminGetWebGPUBuildActive: get('/admin/webgpubuilds/active'),
  adminGetWebGPUBuildPresignedUrl: get(
    (pathParams) => `/admin/webgpubuilds/${pathParams.version}/presigned-url`
  ),
  adminGetWebGPUBuilds: get('/admin/webgpubuilds'),
  adminListGameServers: get((eventId) => `/events/${eventId}/game-servers`),
  adminStartGameServer: post((pathParams) => `/events/${pathParams.eventId}/game-servers`),
  adminStopGameServer: del(
    (pathParams) => `/events/${pathParams.eventId}/game-servers/${pathParams.instanceId}`
  ),
  adminUpdateCollection: post((pathParams) => `/admin/shop/collections/${pathParams.collectionId}`),
  adminUpdateDeeplink: post('/admin/deeplink-info'),
  adminUpdateEvent: post('/admin/events'),
  adminUpdateEventDefaults: put('/admin/event-defaults'),
  adminUpdateProduct: post(
    (pathParams) =>
      `/admin/shop/collections/${pathParams.collectionId}/products/${pathParams.productId}`
  ),
  adminUpdateServerInfo: post('/admin/server-info'),
  adminUpdateServers: post(
    (pathParams) => `/admin/events/${pathParams.eventId}/servers/${pathParams.serverId}`
  ),
  adminUpdateStorefrontInfo: post('/admin/shop'),
  adminUpdateWebGPUBuild: put((pathParams) => `/admin/webgpubuilds/${pathParams.version}`),
  adminUpdateWebGPUBuildActive: put('/admin/webgpubuilds/active'),
  createAnonUser: post('/create-anon-user'),
  createBooking: post((params) => `/bookings/${params.eventId}`),
  createCardanoTransaction: post('/anvil-create-currency-transaction'),
  customizeActionBar: post('/customize-action-bar'),
  customizeActiveAvatar: post('/customize-active-avatar'),
  customizeActiveAvatarIntersect: post('/intersect/customize-active-avatar'),
  customizeActiveOutfit: post('/customize-active-outfit'),
  customizeOutfit: post('/customize-outfit'),
  deleteActionFromActionBar: del(
    (pathParams) => `/action_bars/${pathParams.actionBarId}/slots/${pathParams.slotId}`
  ),
  deleteAssetFromOutfit: del(
    (pathParams) =>
      `/avatars/${pathParams.avatarId}/outfits/${pathParams.outfitId}/categories/${pathParams.categoryId}`
  ),
  deleteBooking: del((pathParams) => `/bookings/${pathParams.eventId}/${pathParams.bookingId}`),
  deleteChatMessage: post(
    (pathParams) => `/chat/event/${pathParams.eventId}/room/${pathParams.roomId}/messages/delete`
  ),
  deleteIVSChatMessage: post(
    (pathParams) => `/ivs-chat/delete-message/event/${pathParams.eventId}/room/${pathParams.roomId}`
  ),
  deleteWallet: del((address) => `/multi/user/settings/wallets/${address}`),
  getActiveEvent: get((eventId) => `/active-events/${eventId}`),
  getActiveEventIntersect: get('/intersect/active-event'),
  getActiveEvents: get('/active-events'),
  getAgenda: get((eventId) => `/agenda/${eventId}`),
  getAnvilAuthPayload: get('/anvil-auth-payload'),
  getAvailableServers: get((eventId) => `/events/${eventId}/available-servers`),
  getBooking: get((pathParams) => `/bookings/${pathParams.eventId}/${pathParams.bookingId}`),
  getBookings: get((eventId) => `/bookings/${eventId}`),
  getChatHistory: get(
    (pathParams) =>
      `/chat/event/${pathParams.eventId}/room/${pathParams.roomId}/messages${
        pathParams.limit ? `?limit=${pathParams.limit}` : ''
      }`
  ),
  getCollection: get((collectionId) => `/collections/${collectionId}`),
  getCurrencyBundles: get('/currency-bundles'),
  getDeeplink: get('/deeplink-info'),
  getDigitalItems: get('/digital-items'),
  getDigitalShops: get('/digital-shops'),
  getFuturebotAssets: get('/futurebot-assets'),
  getIVSChatToken: get((pathParams) => `/ivs-chat-token/event/${pathParams.eventId}`),
  getIVSChatTokenForRoom: get(
    (pathParams) => `/ivs-chat-token/event/${pathParams.eventId}/room/${pathParams.roomId}`
  ),
  getIVSParticipantToken: get(
    (pathParams) =>
      `/ivs-participant-token/event/${pathParams.eventId}/stage/${pathParams.stageIndex}`
  ),
  getIVSParticipantTokenForRoom: get(
    (pathParams) => `/ivs-participant-token/event/${pathParams.eventId}/room/${pathParams.roomId}`
  ),
  getIVSVideoCallToken: get(
    (pathParams) =>
      `/ivs-video-call-token/event/${pathParams.eventId}/stage/${pathParams.stageIndex}`
  ),
  getIVSVideoCallTokenForRoom: get(
    (pathParams) => `/ivs-video-call-token/event/${pathParams.eventId}/room/${pathParams.roomId}`
  ),
  getProduct: get(
    ({ collectionId, productId }) => `/collections/${collectionId}/products/${productId}`
  ),
  getPurchasedItems: get('/purchase-history'),
  getRoom: get((pathParams) => `/rooms/event/${pathParams.eventId}/${pathParams.roomId}`),
  getRooms: get((eventId) => `/rooms/event/${eventId}`),
  getShopItems: get('/shop-items'),
  getSidepanel: get((eventId) => `/sidepanel${eventId ? `?eventId=${eventId}` : ''}`),
  getUnityCurrencyBalance: get('/unity-currency-balance'),
  getUserNFTs: get('/user-nfts'),
  getWallets: get('/multi/user/settings/wallets'),
  joinServer: post('/join-server'),
  leaveServer: post('/leave-server'),
  postChatMessage: post(
    (pathParams) => `/chat/event/${pathParams.eventId}/room/${pathParams.roomId}/messages`
  ),
  postChatReaction: post(
    (pathParams) => `/chat/event/${pathParams.eventId}/room/${pathParams.roomId}/reactions`
  ),
  postNFTBind: post((nftId) => `/nft/${nftId}/bind`),
  postNFTUnbind: post((nftId) => `/nft/${nftId}/unbind`),
  postPasswordEntry: post('/password-entry'),
  postPurchaseItem: post('/purchase-item'),
  postPurchaseItems: post('/purchase-items'),
  postVirtualCurrencyTransaction: post('/post-virtual-currency-transaction'),
  signedPurchasedTransaction: post('/signed-purchased-transaction'),
  stripeCheckoutSession: post('/stripe-checkout-session'),
  stripeCurrencyCheckout: post('/stripe-currency-checkout'),
  submitVirtualCurrencyTransaction: post('/submitted-virtual-currency-transaction'),
  updateBooking: put((pathParams) => `/bookings/${pathParams.eventId}/${pathParams.bookingId}`),
  updateRoom: post((pathParams) => `/rooms/event/${pathParams.eventId}/${pathParams.roomId}`),
  updateUsername: post('/update-username')
};

export default API;
